import React, { useEffect } from 'react';
import { InboundAcceptanceProvider, useInboundAcceptance } from '@contexts/operator/InboundAcceptanceContext';
import Header from '@components/operator/inbounds/acceptance/Header';
import ItemsTable from '@components/operator/inbounds/acceptance/ItemsTable';
import ScanPanel from '@components/operator/inbounds/acceptance/ScanPanel';
import VerificationDrawer from '@components/operator/inbounds/acceptance/VerificationDrawer';
import ProductSelectionModal from '@components/operator/inbounds/acceptance/ProductSelectionModal';
import InboundReceiptSelectorModal from '@components/operator/inbounds/acceptance/InboundReceiptSelectorModal';
import { Spin, Alert, Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';
import ErrorBoundary from '@shared/ErrorBoundary';

const { Content, Sider } = Layout;

function AcceptanceContent() {
  const {
    loading,
    error,
    inbound,
    receiptSelectorOpen,
    activeReceiptSummary,
    receiptLoading,
    handleResumeReceipt,
    handleStartNewReceipt,
    handleCancelReceiptSelector,
  } = useInboundAcceptance();
  const { t } = useTranslation();

  useEffect(() => {
    const contentElement = document.querySelector('.operator-content');
    contentElement?.classList.add('operator-content--full-bleed');

    return () => {
      contentElement?.classList.remove('operator-content--full-bleed');
    };
  }, []);

  console.log('[AcceptanceContent] Render:', { loading, error, inbound });

  if (loading && !inbound) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip={t('common.loading', { defaultValue: '載入中...' })} />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert type="error" message={t('common.error_label')} description={error} showIcon />
      </div>
    );
  }

  if (!inbound) {
    return (
       <div style={{ padding: '24px' }}>
        <Alert type="warning" message={t('common.no_data', { defaultValue: '無資料' })} showIcon />
      </div>
    );
  }

  return (
    <Layout style={{ height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
      <Layout>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <ErrorBoundary homeUrl="/operator">
              <Header />
            </ErrorBoundary>
            <Content style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <ErrorBoundary homeUrl="/operator">
                <ItemsTable />
              </ErrorBoundary>
            </Content>
        </div>
      </Layout>
      <Sider width={400} theme="light" style={{ borderLeft: '1px solid #f0f0f0', zIndex: 10 }}>
        <ErrorBoundary homeUrl="/operator">
          <ScanPanel />
        </ErrorBoundary>
      </Sider>
      
      {/* Global Modals */}
      <VerificationDrawer />
      <ProductSelectionModal />
      <InboundReceiptSelectorModal
        open={receiptSelectorOpen}
        activeReceipt={activeReceiptSummary}
        loading={receiptLoading}
        onResume={handleResumeReceipt}
        onStartNew={handleStartNewReceipt}
        onCancel={handleCancelReceiptSelector}
      />
    </Layout>
  );
}

export default function InboundAcceptance() {
  const initialData = useLoaderData();
  console.log('[InboundAcceptance] Initial Data:', initialData);

  return (
    <ErrorBoundary homeUrl="/operator">
      <InboundAcceptanceProvider initialData={initialData}>
        <AcceptanceContent />
      </InboundAcceptanceProvider>
    </ErrorBoundary>
  );
}
